import keyMirror from 'src/utilities/keyMirror';

export const FAILED_TRANSACTION_REASON = keyMirror({
  ACCOUNT_NOT_FOUND: null,
  ACCOUNT_INACTIVE: null,
  ACCOUNT_BLOCKED: null,
  ACCOUNT_EXCEED_LIMIT: null,
  UNAUTHORIZED_KEY: null,
  INVALID_ACCOUNT_TYPE: null,
  INVALID_SIGNATURE: null,
  INVALID_REQUEST_AMOUNT: null,
  INVALID_SENDER_INFO: null,
  INVALID_RECIPIENT_INFO: null,
  INVALID_REQUEST_ADDITIONAL_DATA: null,
  INSUFFICIENT_BALANCE: null,
  VENDOR_UNDER_MAINTENANCE: null,
  VENDOR_SYSTEM_ERROR: null,
  TIMEOUT: null,
  INTERNAL_SYSTEM_ERROR: null,
  DUPLICATE_INTERNAL_TX_ID: null,
  OTHERS: null,
  VENDOR_IS_NOT_SUPPORTED: null,
  INVALID_DATA: null,
  EXCEPTION: null,
  AMOUNT_EXCEED_LIMIT: null,
  CLIENT_INSUFFICIENT_BALANCE: null,
  SUSPECTED_FRAUD: null,
  INVALID_RECIPIENT_ACCOUNT_NUMBER: null,
  USER_ROUTING_PREFERENCES: null,
});

export const DEFAULT_DATE_FILTER_ALLOWED = [
  'today',
  'this_week',
  'last_1_months',
];

export const DATE_TIME_FORMAT_WITHOUT_TIME = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT_WITH_SECONDS = 'YYYY-MM-DD HH:mm:ss';
export const DATE_TIME_FORMAT_WITH_DEFAULT_TIME = 'YYYY-MM-DD 00:00:00';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
